namespace Matrix.Data {
    export class OwnershipBasisColumns {
        static columnsKey = 'Data.OwnershipBasis';
    }
}
